import {css} from '@emotion/core'
import styled, {Theme, ThemeProps} from '@themes/theme'
import { ProfileImgWrapStyle } from '../Chat/index.style'

const commonNumStyle = (props: ThemeProps) => css`
  padding-right: 4px;
  color: ${props.theme.color.modalTxt};
  font-size: ${props.theme.font.title};
`
const inputH = '48px'
const inputSubH = '18px'
export const MessageWrap = styled.div`
  position: relative;
  height: auto;
  text-align: left;
  .bettor-profile-img-wrap {
    ${ProfileImgWrapStyle};
    display: inline-block;
    width: 45px;
    height: 45px;
    margin-left: 10px;
    margin-right: 9px;
    .profile-img-wrap {
      position:relative;
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      background: ${props => props.theme.color.modalgray};
      .profile-img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        height: auto;
        &.custom-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .tit {
    display: inline-block;
    transform: translateY(-6px);
    font-size: ${props => props.theme.font.title};
    color: ${props => props.theme.color.contentsBg};
  }
  .ant-input {
    width: 80%;
    height: 30px;
    padding-right: 32px;
    line-height: 3rem;
    text-align: right;
    border: none;
    border-radius: 50px;
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.large};
  }
  .heart-wrap {
    margin-top: 18px;
    padding: 0 10px;
    &--list {
      margin-bottom: 7px;
      &--item {
        display: flex;
        justify-content: space-between;
        height: ${inputH};
        line-height: ${inputH};
        margin-bottom: 6px;
        .list-item-txt {
          min-width: 83px;
          margin-right: 6px;
          font-size: ${props => props.theme.font.large};
          font-weight: ${props => props.theme.fontW.medium};
          color: ${props => props.theme.color.contentsBg};
        }
        .list-item-quantity {
          position: relative;
          display: flex;
          justify-content: flex-end;
          font-size: ${props => props.theme.font.large};
          color: ${props => props.theme.color.modalTxt};
          input {
            ${commonNumStyle};
            flex: 1;
            height: ${inputH};
            line-height: ${inputH};
            background-color: transparent;
            border: 0;
            text-align: right;
          }
          .list-item-type {
            position: relative;
            min-width: 13px;
            color: ${props => props.theme.color.modalTxt};
            font-size: ${props => props.theme.font.large};
            svg {
              position: absolute;
              top: 50%;
              left: 50%;
              width: 14px;
              transform: translate(-50%, -50%);
            }
          }
        }
        &:not(.sub) {
          border-bottom: 1px solid ${props => props.theme.color.modalBg};
        }
        &.sub {
          justify-content: flex-end;
          height: ${inputSubH};
          line-height: ${inputSubH};
          margin-bottom: 21px;
          .list-item-txt, .list-item-quantity > * {
            font-size: ${props => props.theme.font.medium};
            font-weight: ${props => props.theme.fontW.medium};
            color: ${props => props.theme.color.modalSubTxt};
          }
          .list-item-type {
            svg {
              width: 12px;
            }
          }
        }
      }
    }
  }
`
export const Num = styled.span`
  ${commonNumStyle};
`
export const SendBtnStyle = (theme: Theme) => css`
  position: absolute;
  left: -14px;
  bottom: 0;
  width: calc(100% + 28px);
  height: 36px;
  border-radius: 0;
`
export const PointStyle = (theme: Theme) => css`
  font-size: ${theme.font.title};
  color: ${theme.color.modalyellow};
`
